import { Button } from 'aimo-ui';
import { FooterButtonContainer } from 'components/sheets/SheetLayout';
import useAfterAuthenticationRedirect from 'hooks/useAfterAuthenticationRedirect';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { View } from 'react-native';
import { useActiveElementStore } from 'stores/activeElementStore';
import { isWeb } from 'utils/deviceUtils';
import { testIdentifiers } from 'utils/testIdentifiers';

type ParkingSignInButtonProps = {
  loading?: boolean;
  testID: string;
  withContainer?: boolean;
};

const ParkingSignInButton = ({
  loading,
  testID,
  withContainer = true,
}: ParkingSignInButtonProps) => {
  const { t } = useTranslation();
  const { navigateToAuthentication, setReturnRedirectToBuyShortTermParking } =
    useAfterAuthenticationRedirect();
  const parkingZoneUid = useActiveElementStore((state) => state.activeElement);

  const handleOnPress = async () => {
    setReturnRedirectToBuyShortTermParking(parkingZoneUid);
    await navigateToAuthentication(isWeb);
  };
  const CustomWrapper = (
    withContainer ? FooterButtonContainer : View
  ) as React.ElementType;

  return (
    <CustomWrapper>
      <Button
        size="l"
        text={t('parking.notSignedIn.button.long')}
        {...testIdentifiers(testID)}
        onPress={handleOnPress}
        loading={loading}
        disabled={loading}
      />
    </CustomWrapper>
  );
};

export default ParkingSignInButton;
